import { User } from "firebase/auth";
import { apiFetch } from "./client";

export interface Club {
  id: string;
  name: string;
  shortName: string | null;
  crest: string | null;
  createdAt: string;
}

export interface AdminClubsPage {
  clubs: Club[];
  total: number;
  page: number;
  pageSize: number;
}

export function getClubs(user: User, params?: { search?: string; page?: number; sortBy?: string; sortDir?: "asc" | "desc" }): Promise<AdminClubsPage> {
  const q = new URLSearchParams();
  if (params?.search) q.set("search", params.search);
  if (params?.page) q.set("page", String(params.page));
  if (params?.sortBy) q.set("sortBy", params.sortBy);
  if (params?.sortDir) q.set("sortDir", params.sortDir);
  return apiFetch(user, `/admin/clubs?${q}`);
}

// Returns every club, unpaginated — for pickers (create-competition club select, club linking)
export function getAllClubs(user: User): Promise<Club[]> {
  return apiFetch<{ clubs: Club[] }>(user, "/admin/clubs?all=true").then((data) => data.clubs);
}

export function createClub(
  user: User,
  data: { name: string; shortName?: string; crest?: string },
): Promise<Club> {
  return apiFetch(user, "/admin/clubs", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function updateClub(
  user: User,
  id: string,
  data: Partial<{ name: string; shortName: string | null; crest: string | null }>,
): Promise<Club> {
  return apiFetch(user, `/admin/clubs/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export function deleteClub(user: User, id: string): Promise<void> {
  return apiFetch(user, `/admin/clubs/${id}`, { method: "DELETE" });
}
